import React, { useState } from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import {
  Box,
  IconButton,
  Typography,
} from '@mui/material';
import {
  KeyboardArrowDown,
  KeyboardArrowRight,
} from '@mui/icons-material';



const sample = {
  "Tasklist": [
    {
      "Project_id": "1130",
      "Project_name": "Fobesoft",
      "Client_id": "1014",
      "Client_name": "Fobesoft",
      "Project_Sdate": "2025-05-01",
      "Project_Edate": "2029-12-31",
      "Tasks": [
        {
          "ItemId": 2135,
          "ItemName": "Invoice Process",
          "Task+Hours": "480",
          "itemtype": "Task",
          "Client_id": "1014",
          "Client_name": "Fobesoft",
          "Approved_hours": "0",
          "Emp_id": 2074,
          "Status": "In Progress",
          "Employee_id": "Vivek Soman",
          "start_date": "26-05-2025",
          "Inprocess_date": "26-05-2025",
          "end_date": "",
          "Priority": "High",
          "Task_comments": [
            {
              "CommentId": 5579,
              "content": "Invoice and POS Process",
              "comments_Date": "31-05-2025",
              "Comment_hrs": "08:00"
            }
          ]
        },
        {
          "ItemId": 2135,
          "ItemName": "Invoice Process",
          "Task+Hours": "480",
          "itemtype": "Task",
          "Client_id": "1014",
          "Client_name": "Fobesoft",
          "Approved_hours": "0",
          "Emp_id": 2073,
          "Status": "In Progress",
          "Employee_id": "Suganya Nagavelu",
          "start_date": "26-05-2025",
          "Inprocess_date": "26-05-2025",
          "end_date": "",
          "Priority": "High",
          "Task_comments": [
            {
              "CommentId": 5578,
              "content": "Invoice processing & uploads ,POS Processing",
              "comments_Date": "31-05-2025",
              "Comment_hrs": "08:00"
            }
          ]
        },
        {
          "ItemId": 2135,
          "ItemName": "Invoice Process",
          "Task+Hours": "480",
          "itemtype": "Task",
          "Client_id": "1014",
          "Client_name": "Fobesoft",
          "Approved_hours": "0",
          "Emp_id": 2072,
          "Status": "In Progress",
          "Employee_id": "Rajalakshmi MP",
          "start_date": "26-05-2025",
          "Inprocess_date": "26-05-2025",
          "end_date": "",
          "Priority": "High",
          "Task_comments": [
            {
              "CommentId": 5576,
              "content": "Invoice-proseeing/Pos-entries",
              "comments_Date": "31-05-2025",
              "Comment_hrs": "08:00"
            }
          ]
        }
      ]
    },
    {
      "Project_id": "1040",
      "Project_name": "Fobesoft SEO",
      "Client_id": "1014",
      "Client_name": "Fobesoft",
      "Project_Sdate": "2024-11-01",
      "Project_Edate": "2026-05-30",
      "Tasks": [
        {
          "ItemId": 2190,
          "ItemName": "Re entered Hours.",
          "Task+Hours": "301",
          "itemtype": "Task",
          "Client_id": "1014",
          "Client_name": "Fobesoft",
          "Approved_hours": "1",
          "Emp_id": 1039,
          "Status": "In Progress",
          "Employee_id": "Vijay M",
          "start_date": "29-05-2025",
          "Inprocess_date": "29-05-2025",
          "end_date": "",
          "Priority": "High",
          "Task_comments": [
            {
              "CommentId": 5341,
              "content": "d",
              "comments_Date": "30-05-2025",
              "Comment_hrs": "02:01"
            },
            {
              "CommentId": 5342,
              "content": "ded",
              "comments_Date": "29-05-2025",
              "Comment_hrs": "03:00"
            }
          ]
        },
        {
          "ItemId": 2193,
          "ItemName": "Remove Project",
          "Task+Hours": "1200",
          "itemtype": "Task",
          "Client_id": "1014",
          "Client_name": "Fobesoft",
          "Approved_hours": "1",
          "Emp_id": 2115,
          "Status": "In Progress",
          "Employee_id": "Churiyadeavan  N",
          "start_date": "30-05-2025",
          "Inprocess_date": "30-05-2025",
          "end_date": "",
          "Priority": "High",
          "Task_comments": [
            {
              "CommentId": 5329,
              "content": "xcvb fgjytkiupi8;yio;ui",
              "comments_Date": "30-05-2025",
              "Comment_hrs": "10:00"
            },
            {
              "CommentId": 5328,
              "content": "nohhhgfdt",
              "comments_Date": "26-05-2025",
              "Comment_hrs": "10:00"
            }
          ]
        }
      ]
    },
    {
      "Project_id": "1056",
      "Project_name": "SOW",
      "Client_id": "1014",
      "Client_name": "Fobesoft",
      "Project_Sdate": "2024-01-01",
      "Project_Edate": "2026-01-31",
      "Tasks": [
        {
          "ItemId": 2189,
          "ItemName": "Hello",
          "Task+Hours": "60",
          "itemtype": "Task",
          "Client_id": "1014",
          "Client_name": "Fobesoft",
          "Approved_hours": "1",
          "Emp_id": 2058,
          "Status": "Completed",
          "Employee_id": "Muthu Pandi",
          "start_date": "29-05-2025",
          "Inprocess_date": "29-05-2025",
          "end_date": "29-05-2025",
          "Priority": "High",
          "Task_comments": [
            {
              "CommentId": 5321,
              "content": "2",
              "comments_Date": "26-05-2025",
              "Comment_hrs": "01:00"
            }
          ]
        }
      ]
    },
  ]
}


const formatTime = (totalMinutes) => {
  if (isNaN(totalMinutes) || totalMinutes == null) return "00:00"; // Handle NaN or null
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
};
const groupedProjects = sample.Tasklist.map((project) => {
  const taskMap = {};

  let hours = 0;

  project.Tasks.forEach((task) => {
    const taskId = task.ItemId;

    hours += parseInt(task["Task+Hours"]);

    if (!taskMap[taskId]) {
      // Create entry if not exists
      taskMap[taskId] = {
        ItemId: task.ItemId,
        task: task.ItemName,
        Status: task.Status,
        Priority: task.Priority,
        TaskHours: task["Task+Hours"],
        comments: [],
      };
    }
    else {
      taskMap[taskId] = {
        ...taskMap[taskId],
        TaskHours: parseInt(taskMap[taskId].TaskHours) + parseInt(task["Task+Hours"])
      }
    }

    task.Task_comments.forEach((comment) => {
      taskMap[taskId].comments.push({
        ...comment,
        Employee: task.Employee_id,
      })
    });
  });

  return {
    Project_id: project.Project_id,
    project: project.Project_name,
    Client_name: project.Client_name,
    sumHours: formatTime(hours),
    tasks: Object.values(taskMap),
  };
});


console.log(groupedProjects, "groupedProjects")


const columns = [
  {
    accessorKey: 'project',
    header: 'Projects',
  },
  {
    accessorKey: 'task',
    header: 'Tasks',
    Cell: () => '',
  },
  {
    accessorKey: 'comment',
    header: 'Comments',
    Cell: () => '',
  },
  {
    accessorKey: 'sumHours',
    header: 'Sum of Hours',
  },
];

const DetailPanel = React.memo(({ row }) => {
  const { tasks } = row.original;
  const [expandedTasks, setExpandedTasks] = useState({});


  console.log(tasks, "sumHours");
  const toggleTask = (index) => {
    setExpandedTasks((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <>
      {tasks.map((task, taskIndex) => (
        <Box key={taskIndex} sx={{ borderBottom: '1px solid #ccc' }}>
          {/* Expandable Task Header */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              padding: '8px 16px',
              backgroundColor: '#f5f5f5',
              cursor: 'pointer',
              '&:hover': { backgroundColor: '#e0e0e0' },
            }}
            onClick={() => toggleTask(taskIndex)}
          >
            <Box sx={{ width: '25%' }} />
            <Box sx={{ width: '5%' }}>
              <IconButton size="small">
                {expandedTasks[taskIndex] ? (
                  <KeyboardArrowDown />
                ) : (
                  <KeyboardArrowRight />
                )}
              </IconButton>
            </Box>
            <Box sx={{ width: '10%' }}>
              <Typography>{task.task}</Typography>
            </Box>

            <Box sx={{ width: '35%' }} />

            {/* Sum of Hours */}
            <Box sx={{ width: '15%', textAlign: 'right' }}>
              <Typography>{formatTime(task.TaskHours)}</Typography>
            </Box>

          </Box>

          {/* Comments */}
          {expandedTasks[taskIndex] &&
            task.comments.map((comment, commentIndex) => (
              <Box
                key={commentIndex}
                sx={{
                  display: 'flex',
                  padding: '4px 16px',
                  fontSize: '0.875rem',
                  backgroundColor: commentIndex % 2 === 0 ? '#fafafa' : '#fff',
                }}
              >
                <Box sx={{ width: '25%' }} />
                <Box sx={{ width: '25%' }} />
                <Box sx={{ width: '35%' }}>{comment.content}</Box>
                <Box sx={{ width: '15%', textAlign: 'right' }}>{comment.Comment_hrs}</Box>
              </Box>
            ))}
        </Box>
      ))}
    </>
  );
});

export const Test = () => {
  const table = useMaterialReactTable({
    columns,
    data: groupedProjects.length > 0 && groupedProjects,
    enableExpanding: true,
    getRowCanExpand: (row) => !!row.original.tasks?.length,
    renderDetailPanel: ({ row }) => <DetailPanel row={row} />,
    muiTableBodyRowProps: ({ row }) => ({
      sx: {
        cursor: row.getCanExpand() ? 'pointer' : 'default',
      },
    }),
  });

  return <MaterialReactTable table={table} />;
};
